// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__lw7tC","title":"ClientReferral_title__24R0C","itemText":"ClientReferral_itemText__1Dpp2"};